import { getSortMetrics } from './getSortMetrics';
import { getWidthMetrics } from './getWidthMetrics';
import type { Chart, RequestedConfig } from './types';
import { VIEW_ONLY_CONFIG_KEYS } from './types';

export const getDataRequestedConfig = (
  config: Chart,
): RequestedConfig<Chart> => {
  const requestedConfig: Record<string, unknown> = { ...config };

  VIEW_ONLY_CONFIG_KEYS.forEach((key) => {
    delete requestedConfig[key];
  });

  // Width metric is view-only elsewhere but must enter the cache key, or stale data lingers.
  const widthMetrics = getWidthMetrics(config);

  if (widthMetrics.length > 0) {
    requestedConfig.widthMetrics = widthMetrics;
  }

  const sortMetrics = getSortMetrics(config);

  if (sortMetrics.length > 0) {
    requestedConfig.sortMetrics = sortMetrics;
  }

  return requestedConfig as RequestedConfig<Chart>;
};
